import React from 'react';
import type { CompanyStat } from '../../types/company';
type StatsRowProps = {
  stats: CompanyStat[];
  label: string;
};
export function StatsRow({
  stats,
  label
}: StatsRowProps) {
  const cols = stats.length === 4 ? 'lg:grid-cols-4' : 'lg:grid-cols-3';
  return <section className="w-full bg-white py-16 lg:py-20" aria-label={label} data-id="element-359" data-mp="2rmy5twko7eif">
      <dl className={`mx-auto grid max-w-shell grid-cols-2 gap-x-6 gap-y-10 px-6 ${cols}`} data-id="element-360" data-mp="2wn2lxlho2784">
        {stats.map(stat => <div key={stat.label} className="border-t border-canvas-line pt-5" data-id="element-361" data-mp="1zvs2765qqyoe">
            <dt className="sr-only" data-id="element-362" data-mp="23zgbbta0u2br">{stat.label}</dt>
            <dd data-id="element-363" data-mp="28y181iq2e3vg">
              <span className="display block text-[34px] font-semibold text-ink sm:text-[48px]" data-id="element-364" data-mp="28xhqw488njih">{stat.value}</span>
              <span className="mt-2 block text-[14px] leading-[1.45] text-ink-muted sm:text-[15px]" data-id="element-365" data-mp="2dqkpiqrvhj5j">{stat.label}</span>
            </dd>
          </div>)}
      </dl>
    </section>;
}